import { getEnv } from '../../../config/env'

const REACT_APP_WP_URL = getEnv('REACT_APP_WP_URL')

export const LINK_CREATE_APP = (token) => `${REACT_APP_WP_URL}?root=2&id=${token}`

export const APPS_FILTERS = [
  {
    field: 'cod_zona_zeus',
    label: 'Zona',
    comboId: 'cod_zona_zeus',
  },
  {
    field: 'solicitud_estado',
    label: 'Estado sol.',
    comboId: 'estados_solicitud_instalador_filtro',
  },
  {
    field: 'presupuesto_estado',
    label: 'Estado pres.',
    comboId: 'estados_presupuesto',
  },
  {
    field: 'presupuestos_tipo',
    label: 'Tipo pres.',
    comboId: 'tipo_presupuesto',
  },
]
